module.exports = __webpack_public_path__ + "static/media/bursts_17.73337f49.svg";